var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noPrint"},[_c('v-navigation-drawer',{style:({
			'z-index': 10,
			'margin-top': _vm.isMobile ? '0rem' : '6rem',
			height: _vm.isMobile ? '100vh' : 'calc(100vh - 6rem)',
		}),attrs:{"app":"","left":"","permanent":_vm.permanent,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}},[_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.items),function(item){return _c('v-list-item',{key:item.DESC,attrs:{"to":item.URL,"tooltip":item.DESC}},[_c('v-list-item-action',[_c('v-icon',[_vm._v(_vm._s(item.ICONE))])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(item.DESC))])],1)],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }